// src/js/_observer.js
import { IntersectionObserverManager } from "@locomotivemtl/intersection-observer-manager";

export default class Observer {
	constructor() {
		this.init();
	}

	init() {
		// Initialize with default rootMargin
		IntersectionObserverManager.init({
			// rootMargin: "0px 0px 0px 0px",
			// callback: (entries) => {
			// 	// Qui puoi gestire logiche globali quando gli elementi entrano nel viewport
			// 	entries.forEach((entry) => {
			// 		if (entry.isIntersecting) {
			// 			// Esempio: entry.target.classList.add('is-inview');
			// 		}
			// 	});
			// },
			rootMargin: "0px 0px 0px 0px",
			callback: () => {},
		});

		console.log("Locomotive Intersection Observer Initialized");
	}
}
